// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide number input arrows */
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    appearance: textfield;
}

body::-webkit-scrollbar {
    width: 8px;
}

body::-webkit-scrollbar-track {
    background: #1b2431;
    /* Match body background */
}

body::-webkit-scrollbar-thumb {
    background-color: #273142;
    /* Scrollbar handle color */
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IAEI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,mBAAmB;AACvB","sourcesContent":["/* Hide number input arrows */\ninput[type=number]::-webkit-inner-spin-button, \ninput[type=number]::-webkit-outer-spin-button { \n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=number] {\n    -moz-appearance: textfield;\n    appearance: textfield;\n}\n\nbody::-webkit-scrollbar {\n    width: 8px;\n}\n\nbody::-webkit-scrollbar-track {\n    background: #1b2431;\n    /* Match body background */\n}\n\nbody::-webkit-scrollbar-thumb {\n    background-color: #273142;\n    /* Scrollbar handle color */\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
